<template>
  <div>
    <div class="kqf-card mg10 search-box mt20">
      <el-form
        :inline="true"
        :model="search"
        size="mini"
        class="demo-form-inline"
      >
        <el-form-item label="受邀人关键字：">
          <el-input
            v-model="search.keyword"
            placeholder="请输入昵称或手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker
            v-model="search.create_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">查询</el-button>
          <el-button @click="refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table
        border
        :data="datas.list"
        height="calc(100vh - 280px)"
        @sort-change="orderby"
      >
        <el-table-column label="UID" width="80" prop="uid"></el-table-column>
        <el-table-column label="用户信息" width="350">
          <template slot-scope="scope">
            <div class="flex">
              <div style="margin-left: 10px">
                <p class="text-over">微信昵称：{{ scope.row.nickname }}</p>
                <p class="text-over">openid：{{ scope.row.openid }}</p>
                <el-link
                  v-clipboard:success="copySuccess"
                  v-clipboard:copy="scope.row.mobile"
                  type="primary"
                  :underline="false"
                  >手机号：{{ scope.row.mobile }}
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推广者" width="350">
          <template slot-scope="scope">
            <div class="flex">
              <p v-if="!scope.row.agent_uid" class="text-info">--</p>
              <div v-else class="flex">
                <div class="ml10">
                  <p class="text-over">
                    微信昵称：{{ scope.row.hasAgent_nickname }}
                  </p>
                  <p class="text-over">
                    openid：{{ scope.row.hasAgent_openid }}
                  </p>
                  <p>
                    <el-link
                      v-clipboard:success="copySuccess"
                      v-clipboard:copy="scope.row.hasAgent_mobile"
                      type="primary"
                      :underline="false"
                      >手机号：{{ scope.row.hasAgent_mobile }}
                    </el-link>
                    <span> ({{ scope.row.agent_uid }}) </span>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="赠送积分" prop="score"></el-table-column>
        <el-table-column label="累计贡献佣金" sortable prop="total_commission">
          <template slot-scope="scope">
            <div>￥{{ scope.row.total_commission }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="注册时间"
          sortable
          width="180"
          prop="created_at"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.created_at }}</p>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex center mt10">
        <div>
          <el-pagination
            @current-change="getList"
            :current-page="search.page"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userIndex } from "../../request/api/user";
export default {
  data() {
    return {
      search: this.getSearch(),
      datas: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getSearch() {
      return {
        keyword: "",
        page: 1,
        agent_uid: Number(this.$route.query.id),
        create_time: [],
        sort: ""
      };
    },
    getList(page) {
      this.search.page = page;
      this.loading = true;
      userIndex({
        page: page,
        keyword: this.search.keyword,
        agent_uid: this.search.agent_uid,
        create_time: this.search.create_time,
        sort: this.search.sort
      })
        .then(res => {
          this.datas = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.search = this.getSearch();
      this.getList(1);
    },
    orderby(e) {
      if (e.order != null) {
        let order = e.order == "descending" ? "desc" : "asc";
        this.search.sort = e.prop + "_" + order;
      } else {
        this.search.sort = "";
      }
      this.getList(1);
    }
  }
};
</script>
<style scoped></style>
